import Immutable from 'immutable';
import reframe from 'nike-re-framejs';
import { TAB_REGISTERED } from './constants';

reframe.regSub('ticketus/homepage/initialized', db => db.getIn(['ticketus', 'homepage', 'initialized']));
reframe.regSub('ticketus/homepage/filter/type', db => db.getIn(['ticketus', 'homepage', 'filter', 'type']));
reframe.regSub('ticketus/homepage/list', db => db.getIn(['ticketus', 'homepage', 'list'], Immutable.Map()));
reframe.regSub('ticketus/homepage/ticketsTab', db => db.getIn(['ticketus', 'homepage', 'ticketsTab'], TAB_REGISTERED));
